import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import stockLocationKeys from '@/api/queries/stockLocations/keyFactory';
import { graphql } from '@/gql';
import {
  CreateStockLocationInput,
  CreateStockLocationMutation as TCreateStockLocationMutation,
} from '@/gql/graphql';

const CreateStockLocationMutation = graphql(`
  mutation CreateStockLocation($input: CreateStockLocationInput!) {
    createStockLocation(input: $input) {
      id
      name
    }
  }
`);

const useCreateStockLocation = (
  options?: UseMutationOptions<
    TCreateStockLocationMutation,
    unknown,
    CreateStockLocationInput
  >
) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};

  return useMutation({
    mutationFn: (input) =>
      gqlClient.request(CreateStockLocationMutation, { input }),
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries({ queryKey: stockLocationKeys.all });
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useCreateStockLocation;
